import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { CartProvider } from "./context/CartContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages publiques
import Home from "./pages/public/Home";
import Contact from "./pages/public/Contact";
import Login from "./pages/public/Login";
import AdminLogin from "./pages/public/AdminLogin";
import Register from "./pages/public/Register";

// Pages client
import Products from "./pages/client/Products";
import ProductDetail from "./pages/client/ProductDetail";
import Profile from "./pages/client/Profile";
import PendingApproval from "./pages/client/PendingApproval";
import Commands from "./pages/client/Commands";

// Pages admin
import AdminDashboard from "./pages/admin/Dashboard";
import AdminCategories from "./pages/admin/Categories";
import AdminProducts from "./pages/admin/Products";
import AdminClients from "./pages/admin/Clients";
import AdminCommands from "./pages/admin/Commands";
import AdminTelegram from "./pages/admin/Telegram";

const App: React.FC = () => {
    return (
        <AuthProvider>
            <CartProvider>
            <NotificationProvider>
                <Router>
                    <Layout>
                        <Routes>
                            {/* Routes publiques */}
                            <Route path="/" element={<Products />} />
                            <Route path="/home" element={<Home />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/login" element={<Login />} />
                            <Route
                                path="/admin/login"
                                element={<AdminLogin />}
                            />
                            <Route path="/register" element={<Register />} />

                            {/* Page d'attente d'approbation */}
                            <Route
                                path="/pending-approval"
                                element={
                                    <ProtectedRoute requireApproval={false}>
                                        <PendingApproval />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Produits et catégories : consultation libre, sans connexion */}
                            <Route path="/products" element={<Products />} />
                            <Route
                                path="/products/:id"
                                element={<ProductDetail />}
                            />

                            {/* Routes client (authentifie) */}
                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <Profile />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/commands"
                                element={
                                    <ProtectedRoute>
                                        <Commands />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Routes admin */}
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/categories"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminCategories />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/products"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminProducts />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/clients"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminClients />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/commands"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminCommands />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/telegram"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminTelegram />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </Layout>
                </Router>
            </NotificationProvider>
            </CartProvider>
        </AuthProvider>
    );
};

export default App;
